import React, { MouseEventHandler } from "react";

import { Team } from "../../../redux/slices";
import styles from "./teams.tab.module.scss";

export interface TeamItemProps {
  handleTeamClick: MouseEventHandler<HTMLDivElement>;
  team: Team;
  playCount: number;
}

const TeamItem = ({ handleTeamClick, team, playCount }: TeamItemProps) => {
  return (
    <div className={styles.teamItem} onClick={handleTeamClick}>
      <div className={styles.teamIconNameContainer}>
        <div className={styles.teamImageContainer}>
          <img className={styles.teamImage} src={team.imageUrl} />
        </div>
        <div className={styles.teamName}>{team.name}</div>
      </div>
      <div className={styles.teamInfoEditContainer}>
        <div className={styles.teamPlayCount}>{playCount}</div>
      </div>
    </div>
  );
};

export default TeamItem;
